import type { MailboxInformation } from '@1js/sydney-types';
import { MailboxType } from '@1js/sydney-types';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isMailboxSharedOrDelegate } from 'owa-account-shared-mailbox-utils';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';
import { isCloudCache } from 'owa-account-source-list-internal';

export function getMailboxInformationForAnnotation(
    mailboxInfo: MailboxInfo | undefined
): MailboxInformation | undefined {
    if (!mailboxInfo) {
        return undefined;
    }

    if (
        isGlobalFeatureEnabled('acct-enable-shared-in-bizchat') &&
        isMailboxSharedOrDelegate(mailboxInfo)
    ) {
        return {
            mailboxType: MailboxType.SharedMailbox,
            mailboxSmtpAddress: mailboxInfo.mailboxSmtpAddress,
            auxiliaryMailboxGuid: mailboxInfo.auxiliaryMailboxGuid ?? undefined,
        };
    }

    if (isGlobalFeatureEnabled('acct-enable-cloud-cache-bizchat')) {
        const account = getCoprincipalAccountForMailboxInfo(mailboxInfo);

        if (account && isCloudCache(account)) {
            return {
                mailboxType: MailboxType.LinkedMailbox,
                mailboxSmtpAddress: account.mailboxInfo.userIdentity,
                auxiliaryMailboxGuid: account.mailboxInfo.auxiliaryMailboxGuid ?? undefined,
            };
        }
    }

    return undefined;
}
